import React, { memo } from 'react';
import styled from 'styled-components';
import { Icon } from 'tmt-ui-kit';
import PropTypes from 'prop-types';

// import withResetStyle from '../../utils/withResetStyle';

const HoverArea = styled.div`
  user-select: none;
`;

const ShareContainer = styled.div`
  float: left;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-top: -2px;
  text-align: center;
  box-sizing: border-box;
`;

const CustomIcon = styled(Icon)`
  font-size: 30px;
  font-weight: 500;
  ${HoverArea}:hover & {
    ${props => props.withHoverEffect && `color: ${props.theme.blue}`}
  }
  ${props => (props.dark ? `color: ${props.theme.darkBlue};` : `color: ${props.theme.white};`)}
`;

const Text = styled.span`
  cursor: pointer;
  display: inline-block;
  font-size: 14px !important;
  font-weight: 300 !important;
  font-family: ${props => props.theme.font};
  line-height: 1.57 !important;
  color: ${props => props.theme.darkBlue};
  padding-top: 4px !important;
  padding-left: 8px !important;

  ${HoverArea}:hover & {
    ${props => props.withHoverEffect && `color: ${props.theme.blue}`}
  }
`;

const ShareButton = props => {
  const { onClick, dark, showText, withHoverEffect } = props;
  return (
    <HoverArea onClick={onClick} >
      <ShareContainer>
        <CustomIcon name="share" dark={dark} withHoverEffect={withHoverEffect}/>
      </ShareContainer>
      {showText && <Text withHoverEffect={withHoverEffect}>Share</Text>}
    </HoverArea>
  );
};

ShareButton.propTypes = {
  onClick: PropTypes.func,
  showText: PropTypes.bool,
  withHoverEffect: PropTypes.bool,
  dark: PropTypes.bool
};

export default memo(ShareButton, (prevProps, nextProps) => {
  if (prevProps.onClick !== nextProps.onClick) return false;
  return true;
});
